import { FinanceType } from '@upstart/harmony/lib/constants';

export enum Tabs {
  SELECTED = 'selected',
  FINANCE_OFFERS = 'finance-offers',
}

export type DeskingTab = FinanceType | Tabs;

export enum InstoreUrlPaths {
  OFFERS = 'offers',
  DOCUMENT_SIGNING = 'document-signing',
  LOAN_CONFIRMATION = 'loan-confirmation',
}
export const FNI_PRESENT_FLOW_QUERY_PARAM = 'fniPresentFlow'; // query param to indicate that the deal is in the FNI present flow
